export const API_ENDPOINTS = {
    signUpClinic: "/clinic/auth/signup",
    signUpUser: "/clinic/auth/user-signup",
    confirmSignUpClinic: "/clinic/auth/signup-confirmation",
    callMe: "/radiologist/auth/me",
    userProfile: "/radiologist/user/profile",
    inviteUser: "/clinic/user/invitation",
    users: "/clinic/user/staff?limit=10&page=1",
    userList: "/clinic/user/staff",
    invitedUser: "/clinic/user/invitation/",
    radiologistCasesBase: "/radiologist/cases",
    cmsMaster: "/clinic/masters"
}